<h4 class="modal-header">
  New Dependent Added
  <span class="close-icon"><mat-icon (click)="cancel()">close</mat-icon></span>
</h4>

<div class="mat-typography">
  <p>Following Future coverage exists for this family, do you want to apply the same for the member</p>
</div>

<div class="content-table dependents-table">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 member-search-table update-coverage-dialog-table">
    <ng-container matColumnDef="personCode">
      <th mat-header-cell *matHeaderCellDef width="70">Person Code</th>
      <td mat-cell *matCellDef="let row">
        {{ row.personCode }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let row">
        {{ row.firstName }} {{ row.lastName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="cardId">
      <th mat-header-cell *matHeaderCellDef>Card/Alt ID</th>
      <td mat-cell *matCellDef="let row">
        {{ row.cardId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="relationshipCode">
      <th mat-header-cell *matHeaderCellDef>Relationship</th>
      <td mat-cell *matCellDef="let row">
        {{ row.relationshipCode }} - {{ row.relationshipValue }}
      </td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th mat-header-cell *matHeaderCellDef>Effective Date</th>
      <td mat-cell *matCellDef="let row">
        {{ row.coverage.startDate | timeStampToDate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="endDate">
      <th mat-header-cell *matHeaderCellDef>End Date</th>
      <td mat-cell *matCellDef="let row">
        {{ row.coverage.endDate | timeStampToDate }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row no-data-row" *matNoDataRow>
      <td class="mat-cell" colspan="8" role="status">No Data Found</td>
    </tr>
  </table>
</div>

<div class="mat-row dialog-btn-row">
  <div class="mat-12 flex justify-content-between">
    <button mat-button class="primary-btn" (click)="addCoverageForDependent()">
      Yes
    </button>
    <button mat-button class="primary-btn" (click)="cancel()">
      No
    </button>
  </div>
</div>